import { render, staticRenderFns } from "./NextVisits.vue?vue&type=template&id=4219453d&scoped=true&"
import script from "./NextVisits.vue?vue&type=script&lang=js&"
export * from "./NextVisits.vue?vue&type=script&lang=js&"
import style0 from "./NextVisits.vue?vue&type=style&index=0&id=4219453d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4219453d",
  null
  
)

export default component.exports